import ApiProxy from 'api/lib/ApiService';
import { URLS } from 'constants/appUrls';
import { ReportSessionData, TableauParameter, TableauReportCardResponse, TableauReportType, ReportSessionModes } from '../../interfaces/reports/tableauReport';

class ReportsProxy {
  static getTypes(facilityId: number): Promise<TableauReportType[]> {
    const url = `${URLS.MHO_API}/TabMenu?fid=${facilityId}`;

    return new Promise((resolve, reject) => {
      ApiProxy.get<any>(
        url,
        (response: any) => {
          resolve(response?.data || '');
        },
        (response: any) => {
          reject(response);
        },
      );
    });
  }

  static async getReport(facilityID: number, reportTypeId: number | null = null): Promise<string> {
    const url = `${URLS.MHO_API}/PdTabLink`;
    const params = {
      facility: facilityID,
      type: reportTypeId,
    };

    const response = await ApiProxy.alternativeGet<any>(url, { params });

    return response?.data || '';
  }

  static async getReportFromHash(facilityID: number, workbookHash: string): Promise<string> {
    const url = `${URLS.MHO_API}/TabLink/${facilityID}/${workbookHash}`;

    return new Promise((resolve, reject) => {
      ApiProxy.get<any>(
        url,
        (response: any) => {
          resolve(response?.data || '');
        },
        (response: any) => {
          reject(response);
        },
      );
    });
  }

  static getReportCards(facilityID: number): Promise<TableauReportCardResponse[]> {
    const url = `${URLS.MHO_API}/TabCard/${facilityID}/0`;

    return new Promise((resolve, reject) => {
      ApiProxy.get<any>(
        url,
        (response: any) => {
          resolve(response?.data || []);
        },
        (response: any) => {
          reject(response);
        },
      );
    });
  }

  static getReportParameters(workbookHash: string): Promise<TableauParameter[]> {
    const url = `${URLS.MHO_API}/TabPara/${workbookHash}`;

    return new Promise((resolve, reject) => {
      ApiProxy.get<any>(
        url,
        (response: any) => {
          resolve(response?.data || []);
        },
        (response: any) => {
          reject(response);
        },
      );
    });
  }

  static sendUserSessionData(facilityID: number, workbookHash: string, sessionData: ReportSessionData[], mode: ReportSessionModes): Promise<number> {
    const url = `${URLS.MHO_API}/TabTracking/${facilityID}/${workbookHash}/${mode}`;

    return new Promise((resolve, reject) => {
      ApiProxy.post<any>(
        url,
        sessionData,
        (response: any) => {
          resolve(response?.data || []);
        },
        (response: any) => {
          reject(response);
        },
      );
    });
  }
}

export default ReportsProxy;
